import React from 'react';
import { Button, Grid } from '@mui/material';
import { Edit } from '@mui/icons-material';

import toastMessage from '../../utils/toast';
import { defaultOffer } from './OfferForm';

import { JobType, OfferType, OrderType } from '../../types';
import { PopupForm, useChangeable } from '../CommonComponents/Form';
import OfferFormFields from './OfferFormFields';
import { updateOffer } from '../../api/offers';
import NotifySentOfferPopup from './NotifySentOfferPopup';

type PropsType = {
    order: OrderType | JobType;
    offer: OfferType;
    refetch: () => void;
};

export default function EditOffer({ order, offer, refetch }: PropsType) {
    const [newOffer, onChange] = useChangeable(defaultOffer);
    const [popupIsOpen, setPopupIsOpen] = React.useState(false);
    const [showNotifySentPopup, setShowNotifySentPopup] = React.useState(false);

    const title = React.useMemo(() => (
        offer.price
            ? 'Föreslå nytt pris'
            : 'Föreslå pris'
    ), [offer.price]);

    const sendOffer = React.useCallback(async () => {
        try {
            await updateOffer({ id: offer.id, body: newOffer });
            setShowNotifySentPopup(true);
            setPopupIsOpen(false);
        } catch (e) {
            toastMessage(e, 'Kunde inte skicka prisförslag, försök igen.');
        } finally {
            refetch();
        }
    }, [newOffer, offer.id, refetch]);

    return (
        <>
            <NotifySentOfferPopup
                open={showNotifySentPopup}
                handleClose={() => setShowNotifySentPopup(false)}
                expiresAt={newOffer.expiresAt}
                price={newOffer.price}
            />
            <PopupForm
                open={popupIsOpen}
                title={title}
                okLabel="Skicka"
                cancelLabel="Avbryt"
                handleOk={sendOffer}
                handleClose={() => setPopupIsOpen(false)}
                okDisabled={!newOffer.price || parseFloat(newOffer.price) <= 0}
            >
                <Grid container spacing={2}>
                    <OfferFormFields
                        price={newOffer.price}
                        expiresAt={newOffer.expiresAt}
                        onChange={onChange}
                        listPrice={order.listPrice}
                        disabled={false}
                    // disabled={!order.isOpen}
                    />
                </Grid>
            </PopupForm>

            <Button
                variant="outlined"
                color="primary"
                startIcon={<Edit />}
                onClick={() => setPopupIsOpen(true)}
            >
                {title}
            </Button>
        </>
    );
}
